import { MessageCircle } from "lucide-react";
import { SITE, waLink } from "@/lib/site";

export default function FloatingWhatsApp() {
  return (
    <a
      data-testid="floating-whatsapp"
      href={waLink(`Hola ${SITE.brandShort}, me gustaría más información.`)}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl wa-pulse hover:scale-110 transition-transform duration-300"
      style={{ boxShadow: "0 12px 30px -10px rgba(37,211,102,0.7)" }}
    >
      <MessageCircle size={26} className="md:w-7 md:h-7" />
    </a>
  );
}
